import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import { IDS } from "../../utils/IDS";

// Thunk for getting all CARTS

export const postCart = createAsyncThunk(
  "post-cart",
  async ({ data, isSignIn }, { rejectWithValue }) => {
    // console.log({ postCart_data: data });
    try {
      if (isSignIn) {
        const response = await POST(APIS.CART.CART, data);
        return response;
      } else {
        const item = {
          quantity: 1,
          product_id: data?.product_id,
          variant_id: data?.variant_id,

          Product: {
            name: data?.Product?.name,
            image: data?.Product?.image,
            tax_percentage: data?.Poduct?.tax_percentage,
          },
          Product_Variant: {
            name: data?.variant_name,
            mrp: data?.mrp,
            price: data?.price,
            description: data?.description,
          },
        };

        // console.log({ postCart_item: item });


        const existingCart = Cookies.get("omtapovan_cart");
        let updatedCart = existingCart ? JSON.parse(existingCart) : [];

        if (updatedCart.length > 0) {
          const existingStoreId = updatedCart[0].store_id;

          if (existingStoreId !== item.store_id) {
            return rejectWithValue(
              "One cart is already in process for another store"
            );
          }
        }
        const existingItemIndex = updatedCart.findIndex(
          (cartItem) =>
            cartItem.product_id === item.product_id
          // &&
          //   cartItem.variant_id === item.variant_id
        );

        if (existingItemIndex > -1) {
          updatedCart[existingItemIndex].quantity += item.quantity;
        } else {
          updatedCart.push(item);
        }

        // console.log({ postCart_updatedCart: updatedCart });

        Cookies.set("omtapovan_cart", JSON.stringify(updatedCart));
        return { success: true, data: updatedCart };
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postCartQuantity = createAsyncThunk(
  "post-cart-quantity",
  async (data, { rejectWithValue }) => {
    // console.log({ postCartQuantity_data: data });
    try {
      console.log("data in cart quanitity reducer", data);

      if (data?.isSignIn) {
        const response = await POST(APIS.CART.CART_QUANTITY, data);
        return response;
      } else {
        const cartFromCookies = Cookies.get("omtapovan_cart");

        if (cartFromCookies) {
          const cartData = JSON.parse(cartFromCookies);
          const foundItemIndex = cartData.findIndex(
            (item) =>
              item.product_id === data?.product_id
            // &&
            //   item.variant_id === data?.variant_id
          );

          if (foundItemIndex > -1) {
            if (data?.type === "add") {
              cartData[foundItemIndex].quantity += 1;
            } else if (data?.type === "minus") {
              if (cartData[foundItemIndex].quantity > 1) {
                cartData[foundItemIndex].quantity -= 1;
              } else {
                cartData.splice(foundItemIndex, 1);
              }
            }
            Cookies.set("omtapovan_cart", JSON.stringify(cartData));
            return { data: { success: true, data: cartData } };
          } else {
            return { data: { success: false, data: null } };
          }
        } else {
          return { data: { success: false, data: null } };
        }
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addToCard = createAsyncThunk(
  "auth/add-to-card",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.CART.CART, data);

      return response?.data?.token;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting all CARTS
export const getAllCart = createAsyncThunk(
  "get-all-cart",
  async (isSignIn, { rejectWithValue }) => {
    try {
      if (isSignIn) {
        const response = await GET(APIS.CART.CART);
        return response;
      } else {
        const cartFromCookies = Cookies.get("omtapovan_cart");
        if (cartFromCookies) {
          // Ensure the data is parsed correctly if it's a string
          let cartData = cartFromCookies;
          try {
            // Only parse if cartFromCookies is a string
            if (typeof cartFromCookies === "string") {
              cartData = JSON.parse(cartFromCookies);
            }
            const response = await POST(
              APIS.CART.GET_ALL_CART_WITHOUT_LOGIN,
              cartData
            );

            if (response?.data?.dataToIndex?.length > 0) {
              const cartFromCookies = Cookies.get("omtapovan_cart");
              const cartIndexesFromCookies = JSON.parse(
                cartFromCookies || "[]"
              );
              cartIndexesFromCookies.forEach((index) => {
                if (index >= 0 && index < cartData.length) {
                  cartData.splice(index, 1);
                }
              });
            }
            return response;
          } catch (error) {
            console.error("Error parsing cart data:", error);
            return [];
          }
        } else {
          return [];
        }
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Thunk for getting CART
export const getCart = createAsyncThunk(
  "get-cart",
  async ({ id, isSignIn }, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.CART.CART + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postToLoginCart = createAsyncThunk(
  "post-all-to-cart",
  async (_, { rejectWithValue }) => {
    try {
      let cartItems = [];
      const existingCart = Cookies.get("omtapovan_cart");

      if (existingCart) {
        cartItems = JSON.parse(existingCart);
      }

      if (cartItems.length > 0) {
        const postResponses = await Promise.all(
          cartItems.map(async (value) => {
            const response = await POST(APIS.CART.CART, value);
            // console.lsog({ responseresponse: response });
            return response;
          })
        );
        const allSuccess = postResponses.every(
          (response) => response?.status === 200
        );
        await Cookies.remove("omtapovan_cart");

        if (allSuccess) {
          console.log("All items successfully posted to the server");
          await Cookies.remove("omtapovan_cart");
          return { success: true };
        } else {
          console.log("Failed to post some items to the cart");
          return rejectWithValue("Failed to post some items to the cart");
        }
      } else {
        console.log("No items in the cart, removing session data");
        await Cookies.remove("omtapovan_cart");
        return { success: true };
      }
    } catch (error) {
      console.error("Error in posting cart items:", error);
      return rejectWithValue(error.message);
    }
  }
);
// Thunk for Checking itme in  CART

// Thunk for posting CART

// Thunk for Change Quanitity

// Thunk for delete cart
export const deleteAllCart = createAsyncThunk(
  "delete-cart",
  async ({ id, isSignin, product_id, varient_id }, { rejectWithValue }) => {
    try {
      if (isSignin) {
        const response = await DELETE(APIS.CART.CART + `/${id}`);
        return response?.data;
      } else {
        const cartData = Cookies.get("omtapovan_cart");
        if (cartData) {
          let cart = JSON.parse(cartData);

          const updatedCart = cart.filter(
            (item) =>
              !(
                item.product_id === product_id && item.variant_id === varient_id
              )
          );

          Cookies.set("omtapovan_cart", JSON.stringify(updatedCart), {
            expires: 7,
            path: "/",
          });

          return { success: true };
        } else {
          return { success: false, message: "No cart found in cookies" };
        }
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const cartSlice = createSlice({
  name: "cart",
  initialState: {
    allCarts: [],
    singleCart: {},
    Cart: false,
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCart.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getAllCart.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.allCarts = action.payload || [];

      })
      .addCase(getAllCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getCart.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.singleCart = action.payload?.data || {};

      })
      .addCase(getCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(postCart.pending, (state) => {
        state.status = "loading";

      })
      .addCase(postCart.fulfilled, (state, action) => {
        state.status = "succeeded";

      })
      .addCase(postCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(postCartQuantity.pending, (state) => {
        state.status = "loading";

      })
      .addCase(postCartQuantity.fulfilled, (state, action) => {
        state.status = "succeeded";

      })
      .addCase(postCartQuantity.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(addToCard.pending, (state) => {
        state.status = "loading";

      })
      .addCase(addToCard.fulfilled, (state, action) => {
        state.status = "succeeded";

      })
      .addCase(addToCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(deleteAllCart.pending, (state) => {
        state.status = "loading";

      })
      .addCase(deleteAllCart.fulfilled, (state, action) => {
        state.status = "succeeded";

      })
      .addCase(deleteAllCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      });
  },
});

export default cartSlice.reducer;
